import { render } from "./SetWinnersDialog.vue?vue&type=template&id=bcc28cd2&scoped=true"
import script from "./SetWinnersDialog.vue?vue&type=script&lang=js"
export * from "./SetWinnersDialog.vue?vue&type=script&lang=js"

import "./SetWinnersDialog.vue?vue&type=style&index=0&id=bcc28cd2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc28cd2"]])

export default __exports__